import { render } from "./PositionIcon.vue?vue&type=template&id=c7f31e10"
import script from "./PositionIcon.vue?vue&type=script&lang=js"
export * from "./PositionIcon.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__